import {UnsortableTable} from './UnsortableTable';
import {listData} from '../../constants/listData';
import Error from '../common/Error';
import useFetch from '../../hooks/useFetch';
import Spinner from './Spinner';

type UnsortableListProps = {
  id: Nullable<string | number>;
  name: string;
  entityKey: string
}

export const UnsortableList = ({
  id, name, entityKey
}: UnsortableListProps) => {
  const entity = listData[entityKey];

  const [data, isLoading, error] = useFetch(entity.fetchUrl(id));

  if (error) {
    return <Error message={error?.message} />;
  }

  const tableContent = isLoading ?
    (<Spinner loadingText={entity?.loadingText} />) :
    (<UnsortableTable
      entity={entity}
      content={data}
      emptyTableMsg={entity?.emptyMessage(name)}
    />);

  return (
    <div className="tab-content">
      <h3 className="tab-header">{entity?.header}</h3>
      {tableContent}
    </div>
  );
};

export default UnsortableList;
